const ENABLED_SIDEBAR_ROUTES = ['contacts', 'movies']

function getItemRouteName(item) {
  if (!item || !item.route) return null
  return typeof item.route === 'string' ? item.route : item.route.name
}

export function isSidebarRouteEnabled(routeName) {
  return ENABLED_SIDEBAR_ROUTES.includes(routeName)
}

export function isSidebarItemEnabled(item) {
  return isSidebarRouteEnabled(getItemRouteName(item))
}

export function isSidebarGroupEnabled(item) {
  if (!item || !Array.isArray(item.children)) return false

  return item.children.some(child => {
    if (child.children) {
      return isSidebarGroupEnabled(child)
    }

    return isSidebarItemEnabled(child)
  })
}
